let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3YI2r")).then(() => parcelRequire('kKp2J'));